import { handleJSON, stringifyParams } from '@/utils/fetch-utils';
import { headers } from './index';
import transformDownloadClassesParams from './adapters/download-classes-adapter';

const { API_URL, LIVE_INSTRUCTION_API_URL } = process.env;

export default {
  endpoints: {
    classes: query => `${LIVE_INSTRUCTION_API_URL}/v0/calendar/classes/all${query}`,
    delete: userId => `${API_URL}/teacher-admins/${userId}/all-classes/delete/`,
    download: (userId, query) => `${API_URL}/teacher-admins/${userId}/all-classes/download-reports/${query}`,
    teachers: `${API_URL}/teachers/`,
    formOptions: `${LIVE_INSTRUCTION_API_URL}/v0/admin/calendar/classes/group/form-options`,
    groupClass: `${LIVE_INSTRUCTION_API_URL}/v0/admin/calendar/classes/group/`,
    enrollment: classId => `${LIVE_INSTRUCTION_API_URL}/v0/admin/calendar/classes/group/${classId}/enrollments`,
  },

  fetchClasses({ ordering, ...otherParams }) {
    const translatedParams = { ...otherParams };
    if (ordering) {
      translatedParams.order_by = ordering;
    }

    const query = stringifyParams(translatedParams);
    const endpoint = this.endpoints.classes(query);

    const options = {
      method: 'GET',
      headers: headers(),
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  deleteClasses(userId, classes) {
    const endpoint = this.endpoints.delete(userId);

    const options = {
      method: 'DELETE',
      headers: headers(),
      body: JSON.stringify(classes),
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  downloadClasses(userId, params) {
    const transformedParams = transformDownloadClassesParams(params);
    const query = stringifyParams(transformedParams);
    const endpoint = this.endpoints.download(userId, query);

    const options = {
      method: 'GET',
      headers: headers(),
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchTeachers() {
    const endpoint = this.endpoints.teachers;

    const options = {
      method: 'GET',
      headers: headers(),
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  editEnrollment(classId, payload) {
    const endpoint = this.endpoints.enrollment(classId);

    const options = {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify(payload),
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  fetchFormOptions() {
    const endpoint = this.endpoints.formOptions;

    const options = {
      method: 'GET',
      headers: headers(),
    };

    return fetch(endpoint, options).then(handleJSON);
  },

  createGroupClass(classData) {
    const endpoint = this.endpoints.groupClass;

    const options = {
      method: 'POST',
      headers: headers(),
      body: JSON.stringify(classData),
    };

    return fetch(endpoint, options).then(handleJSON);
  },
};
